import React from 'react';
import { Form, Input, notification, Spin } from 'antd';
import { Button, Icon } from 'semantic-ui-react';
import { observer } from 'mobx-react';
import moment from 'moment';
import './ModalCreate.scss';
import Modal from '../../shared/Modal';
import AMATimeUnitModifyStore from './Store';
import { getAMATimeUnitModifyInfo, saveAMATimeUnitModify } from './Service';
import { formatDate } from '../../../utils/functions';

@observer
class ModalCreate extends React.Component {
  state = {
    loading: true,
    data: null,
  };

  handleSave = () => {
    const { data } = this.state;
    if (data.TimeUnit < 0 || data.StartTime < 0 || !data.EndTime < 0) {
      notification.destroy();
      notification.error({
        message: 'Error',
        description: 'Invalid form',
        duration: 3,
      });
    } else {
      var submitData = data;
      Promise.all([saveAMATimeUnitModify(submitData)])
        .then(([response]) => {
          if (response.status === 'success') {
            notification.destroy();
            notification.success({
              message: 'Success',
              description: 'Data has been saved successfully.',
              duration: 3,
            });
            AMATimeUnitModifyStore.refetch({}, true);
            this.props.onCancel();
          }
        })
        .catch(() => {
          notification.destroy();
          notification.error({
            message: 'Error',
            description: 'An error occurred, please try again',
            duration: 3,
          });
        });
    }
  };
  componentDidMount() {
    const { id } = AMATimeUnitModifyStore.modalParams;
    if (id) {
      Promise.all([getAMATimeUnitModifyInfo(id)]).then(([itemInfo]) => {
        this.setState({
          loading: false,
          data: itemInfo.objItem,
        });
      });
    } else {
      this.setState({
        loading: false,
        data: {
          Id: 0,
          Key: '',
          Label: '',
          Target: 0,
        },
      });
    }
  }

  handleFieldChange = fieldName => event => {
    const { data } = this.state;
    const value = event ? (event.target ? event.target.value : event) : null;
    this.setState({
      data: {
        ...data,
        [fieldName]: value,
      },
    });
  };

  convertDate = dateStr => {
    if (dateStr) {
      if (typeof dateStr === 'string') {
        if (dateStr.search('/Date') !== -1) {
          const date = formatDate(dateStr, true);
          return moment(date, 'DD MMM YYYY, HH:mm');
        }
        return moment(dateStr, 'DD/MM/YYYY');
      }
      return dateStr;
    }
    return null;
  };

  render() {
    const { record, id } = AMATimeUnitModifyStore.modalParams;
    const { open } = AMATimeUnitModifyStore;
    const { data, loading } = this.state;

    return (
      <Modal
        width={800}
        onCancel={this.props.onCancel}
        visible={open}
        footer={
          <React.Fragment>
            <Button color="blue" onClick={this.handleSave}>
              Save
            </Button>
            <Button color="red" onClick={this.props.onCancel}>
              <Icon name="close" />
              Close
            </Button>
          </React.Fragment>
        }
        title={!id ? 'Add Modifying Unit' : record.Code}
      >
        {loading ? (
          <Spin size="large" />
        ) : (
          <Form name="conversation" className="conversation-form">
            <Form.Item
              label="Code"
              required
              validateStatus={!data.Code ? 'error' : null}
              help={!data.Code ? 'This field is required' : null}
            >
              <Input value={data.Code} onChange={this.handleFieldChange('Code')} />
            </Form.Item>
            <Form.Item label="Description">
              <Input.TextArea rows={4} value={data.Description} onChange={this.handleFieldChange('Description')} />
            </Form.Item>
            <Form.Item
              label="Modifying Unit"
              required
              validateStatus={data.ModifyUnit < 0 ? 'error' : null}
              help={!data.Name ? 'This field is required' : null}
            >
              <Input type="number" value={data.ModifyUnit} onChange={this.handleFieldChange('ModifyUnit')} />
            </Form.Item>
          </Form>
        )}
      </Modal>
    );
  }
}

export default ModalCreate;
